import fetchCLUsForParcel from "./fetchCLUsForParcel";

export default async function loadCLUMapData(aerialMap) {
  const requests = aerialMap.data.map((polygon) => fetchCLUsForParcel(polygon));

  const cluPolyFeatures = await Promise.all(requests);
  return cluPolyFeatures.reduce((memo, data) => [...memo, ...data], []);
}
